<template>
  <div class="win">
    <div class="back" v-if="certificate">
      <canvas id="myCanvas" width="300" height="604"></canvas>
      <img
        id="scream"
        src="../assets/certificate_content.png"
        alt="The Scream"
        width="300"
        height="604"
        style="display: none; visibility: hidden;"
      />
    </div>
  </div>
</template>

<script>
import queryString from 'query-string';
import axios from 'axios';
import moment from 'moment';
export default {
  name: 'VideoPlayerLand',
  data: function() {
    return {
      certificate: {
        get_time: '2023年3月4号',
        invalid_time: '2023年3月4号',
        certificate_code: 'XFCCCA',
      },
      qrcodeUrl: window.location.href,
    };
  },
  mounted() {
    const searchString = location.hash.split('?')[1];
    const searchParams = queryString.parse(searchString);
    axios
      .get(
        `https://portal.ourbethel.cn/api/base/certificates/detail_from_mobile_web?certificate_id=${searchParams.certificate_id}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          this.certificate = res.data.data;

          var c = document.getElementById('myCanvas');
          var ctx = c.getContext('2d');

          // const img = document.getElementById('scream');
          // ctx.drawImage(img, 0, 0);

          ctx.font = '18px Arial';
          ctx.textAlign = 'center';
          ctx.fillStyle = '#153b60';
          ctx.fillText('美国培声听力语言中心以其', 150, 96);
          ctx.fillText('博鳌培声国际医学中心', 150, 120);

          ctx.font = 'bold 24px Arial';
          ctx.textAlign = 'center';
          ctx.fillStyle = '#153b60';
          ctx.fillText(`授予 李艺轩`, 150, 176);

          ctx.font = '14px Arial';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'white';
          ctx.fillText(`DREAM-S儿童语言能力筛查资格证书`, 150, 300);
        }
      });
  },
  methods: {
    moment,
    onClick() {
      window.location.href = 'https://www.ourbethel.cn/cert';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.win {
  background-color: #3f7eef;
  width: 100vw;
  min-height: 100vh;
}

.back {
  background-image: url('../assets/certificate_back.png');
  width: 100vw;
  background-size: contain;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content {
  background-image: url('../assets/certificate_content.png');
  width: 350px;
  height: 705px;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 40px;
}
#myCanvas {
  background-color: transparent;
}
</style>
